import { render, staticRenderFns } from "./ImportTaskCard.vue?vue&type=template&id=1bf983d8&scoped=true"
import script from "./ImportTaskCard.vue?vue&type=script&lang=js"
export * from "./ImportTaskCard.vue?vue&type=script&lang=js"
import style0 from "./ImportTaskCard.vue?vue&type=style&index=0&id=1bf983d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf983d8",
  null
  
)

export default component.exports